import React from 'react';
import AgentManagement from '../components/management/AgentManagement';

const AgentManagementPage = () => {
  return (
    <div className="agent-management-page">
      <AgentManagement />
    </div>
  );
};

export default AgentManagementPage;